import React, { useContext, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../commonComponents/translate';
import Carousel from '../../../../commonComponents/carousel/Carousel';
import JourneyProp from '../../propTypes/journeyProp';
import JourneyCarouselItem from './JourneyCarouselItem';
import JourneyStepProp from '../../propTypes/journeyStepProp';
import LoggedUserContext from '../../../../contextProviders/LoggedUserContext';

function JourneyCarousel(props) {
  const {
    t,
    journey,
    selected,
    onSelection,
    isShowingAll,
    onToggleShowAll,
    isEnrolled,
    onEnroll,
    enrollLabel,
    awaitingPayment,
  } = props;
  const { loggedUser } = useContext(LoggedUserContext);
  const steps = journey.steps || [];
  const carouselReset = useRef(null);
  useEffect(() => {
    if (carouselReset.current) {
      const selectedStepIndex = steps.findIndex(
        s => selected && s._id === selected._id,
      );
      if (selectedStepIndex !== -1) {
        carouselReset.current.scrollToIndex(selectedStepIndex);
      } else {
        carouselReset.current.reset();
      }
    }
  }, [selected]);

  return steps.length > 0 ? (
    <div
      className="m-portlet m-portlet--rounded m-portlet--rounded-force"
      style={{ position: 'relative' }}
    >
      {!isEnrolled && (
        <div className="enroll-overlay">
          {/* BRAVON-6462: while the order waits on an offline payment the
              steps stay locked, but the overlay explains why instead of
              selling the journey a second time. The button has no `onEnroll`
              guard, so it must be removed here rather than defused above. */}
          <h2 className="enroll-title">
            {awaitingPayment
              ? t('academy.pendingPayment.title')
              : t('journey_enrollToday')}
          </h2>
          <p className="enroll-message">
            {awaitingPayment
              ? t('academy.pendingPayment.message')
              : t('journey_enrollMessage')}
          </p>
          {awaitingPayment ? (
            <span className="awaiting-payment-label">
              {t('academy.awaitingPaymentConfirmation')}
            </span>
          ) : (
            <button
              type="button"
              onClick={onEnroll}
              className="btn m-btn--pill btn-dynamic enroll-button"
            >
              {loggedUser
                ? enrollLabel || t('academy_enroll')
                : t('academy_enroll')}
            </button>
          )}
        </div>
      )}
      <div className="m-portlet__body course-container-body journey-overall-carousel-background">
        <hr className="middle-line" />
        <Carousel ref={carouselReset}>
          {steps.map((step, index) => (
            <JourneyCarouselItem
              isSequential={journey.isSequential}
              active={selected && selected._id === step._id}
              onClick={() => onSelection(step._id)}
              key={step._id}
              stepCount={steps.length}
              index={index}
              step={step}
            />
          ))}
        </Carousel>
        {loggedUser && (
          <button
            type="button"
            onClick={onToggleShowAll}
            className="landing-certification-browse btn m-btn--pill btn-dynamic"
            style={{ display: 'flex', alignItems: 'center' }}
          >
            {isShowingAll ? (
              <>
                <i className="la la-close" />
                {t('landing_journey_close_btn')}
              </>
            ) : (
              <>
                <i className="fa fa-expand-arrows-alt" />
                {t('landing_journey_all_btn')}
              </>
            )}
          </button>
        )}
      </div>
    </div>
  ) : null;
}

JourneyCarousel.propTypes = {
  t: PropTypes.func.isRequired,
  journey: PropTypes.shape(JourneyProp.propType).isRequired,
  selected: PropTypes.shape(JourneyStepProp.propType).isRequired,
  onSelection: PropTypes.func.isRequired,
  isShowingAll: PropTypes.bool.isRequired,
  onToggleShowAll: PropTypes.func.isRequired,
  isEnrolled: PropTypes.bool.isRequired,
  onEnroll: PropTypes.func.isRequired,
  enrollLabel: PropTypes.string,
  awaitingPayment: PropTypes.bool,
};

JourneyCarousel.defaultProps = {
  enrollLabel: null,
  awaitingPayment: false,
};

export default translate(JourneyCarousel);
